import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import * as ICAL from "ical.js";
import "./CalendarComponent.css"; // optional for styling

function CalendarComponent({ title, icalUrl }) {
  const [bookings, setBookings] = useState([]);
  const [date, setDate] = useState(new Date());

  const fetchICal = async () => {
    try {
      const response = await fetch(icalUrl);
      if (!response.ok) throw new Error("Failed to fetch calendar data");
      const icalText = await response.text();

      // Parse iCal
      const jcalData = ICAL.parse(icalText);
      const comp = new ICAL.Component(jcalData);
      const vevents = comp.getAllSubcomponents("vevent");

      // Extract events
      const parsedEvents = vevents.map((vevent) => {
        const event = new ICAL.Event(vevent);
        return {
          start: event.startDate.toJSDate(),
          end: event.endDate.toJSDate(),
          summary: event.summary || "Booking",
        };
      });

      setBookings(parsedEvents);
    } catch (error) {
      console.error(`❌ Error fetching iCal for ${title}:`, error);
    }
  };

  // Fetch once and refresh hourly
  useEffect(() => {
    fetchICal();
    const interval = setInterval(fetchICal, 60 * 60 * 1000); // every hour
    return () => clearInterval(interval);
  }, [icalUrl]);

  // Check if a date falls within any booked range
  const isBooked = (day) => {
    // Start and end of the day we are checking
    const dayStart = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate(),
      0,
      0,
      0
    );
    const dayEnd = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate(),
      23,
      59,
      59
    );

    // Check against all bookings
    return bookings.some((b) => {
      const adjustedEnd = new Date(b.end);
      adjustedEnd.setDate(adjustedEnd.getDate() - 1); // make checkout day free
      return b.start <= dayEnd && adjustedEnd >= dayStart;
    });
  };

  return (
    <div className="calendar-wrapper">
      <h2>{title}</h2>
      <Calendar
        onChange={setDate}
        value={date}
        tileClassName={({ date }) => (isBooked(date) ? "booked" : "")}
      />
    </div>
  );
}

export default CalendarComponent;
